// utils/marketMatching.js
export function marketMatchesScope(marketTypeId, scope) {
    const numericMarketTypeId = Number(marketTypeId)

    if (scope.only_markets_config && scope.only_markets_config.length) {
        const allowedIds = scope.only_markets_config.map(m => Number(m.market_type_id))
        if (!allowedIds.includes(numericMarketTypeId)) return false
    }
    if (scope.exclude_markets_config && scope.exclude_markets_config.length) {
        const excludedIds = scope.exclude_markets_config.map(m => Number(m.market_type_id))
        if (excludedIds.includes(numericMarketTypeId)) return false
    }
    return true
}
